import axios from 'axios'
import store from '@/store'
import Cookies from 'js-cookie'

axios.defaults.headers.common['Authorization'] = `Bearer ${Cookies.get('token', { domain: process.env.DOMAIN })}`

const API = process.env.API_URL + '/api'

const config = {
  headers: {
    'Accept': 'application/ld+json',
    'Cache-Control': 'no-transform'
  }
}

const templates = {

  pagination (page) {
    const limit = store.getters['templates/pagination'].itemsPerPage
    const offset = Math.ceil(((page - 1) * limit))
    return {
      'limit': limit,
      'offset': offset
    }
  },

  async count (search = '') {
    return axios.get(`${API}/Templates/count`, {
      params: {
        where: {
          name: {
            like: `.*${search}.*`,
            options: 'i'
          }
        }
      },
      config
    })
  },

  async fetch ({ page, search = '' }) {
    return axios.get(`${API}/Templates`, {
      params: {
        filter: {
          ...this.pagination(page),
          'order': 'createdAt DESC',
          where: {
            name: {
              like: `.*${search}.*`,
              options: 'i'
            }
          }
        }
      },
      config
    })
  },

  async fetchOne (id) {
    return axios.get(`${API}/Templates/${id}`, {
      config
    })
  },

  async countOne (id) {
    return axios.get(`${API}/Templates/${id}/lists/count`, {
      config
    })
  },

  async create (template) {
    return axios.post(`${API}/Templates`, template, {
      config
    })
  },

  async update (id, template) {
    return axios.patch(`${API}/Templates/${id}`, template, {
      config
    })
  },

  async delete (id) {
    return axios.delete(`${API}/Templates/${id}`, {
      config
    })
  },

  async url (id) {
    return axios.get(`${API}/my-widget/url/${id}`, {
      config
    })
  },

  async updateSections (templateId, sections) {
    return axios.patch(`${API}/Templates/${templateId}`, {
      _sections: sections
    }, {
      config
    })
  }

}

const players = {

  pagination (page) {
    const limit = store.getters['players/pagination'].itemsPerPage
    const offset = Math.ceil(((page - 1) * limit))
    return {
      limit: limit,
      offset
    }
  },

  count () {
    return axios.get(`${API}/cachedPlayers/count`, {
      params: {
        where: {
          refCountry: store.getters['players/country']
        }
      },
      config
    })
  },

  fetch (page, search, filter) {
    let where = {}

    where[filter] = search
    return axios.get(`${API}/cachedPlayers/findWithFilter`, {
      params: {
        filter: {
          ...this.pagination(page),
          where
        }
      },
      config
    })
  }

}

const auth = {
  updateToken (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  },

  fetchUser () {
    return axios.get(`${API}/me`, { config })
  }
}

export { templates, players, auth }



// WEBPACK FOOTER //
// ./src/api/index.js